module.exports = __webpack_public_path__ + "img/bg-header.7cb55b97.jpeg";